import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#EBECF5\" d=\"M0 0h20v20H0z\"></path><g clip-path=\"url(#a)\"><path fill=\"#fff\" d=\"M-64-373h1286v941H-64z\"></path><circle cx=\"10\" cy=\"10\" r=\"9.5\" fill=\"#C7FFC5\" stroke=\"#077401\"></circle><circle cx=\"10\" cy=\"10\" r=\"5.833\" fill=\"#077401\"></circle><rect width=\"61\" height=\"221\" x=\"-20.5\" y=\"-59.5\" stroke=\"#9747FF\" stroke-dasharray=\"10 5\" rx=\"4.5\"></rect></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M-64-373h1286v941H-64z\"></path></clipPath></defs>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }